import {
  Component,
  forwardRef,
  Input
} from '@angular/core';

import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

/**
 * Auto-incrementing integer used to generate unique ids for checkbox components.
 */
let nextId = 0;

/**
 * Provider Expression that allows sky-checkbox to register as a ControlValueAccessor.
 * This allows it to support [(ngModel)].
 */
// tslint:disable:no-forward-ref no-use-before-declare
export const SKY_RADIO_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SkyRadioComponent),
  multi: true
};
// tslint:enable


export class SkyRadioComponent implements ControlValueAccessor {
  /**
   * Hidden label for screen readers.
   */
  
  public label: string = '';

  /**
   * Id of label for the checkbox.
   */
  
  public labelledBy: string;

  
  public id: string = `sky-radio-${++nextId}`;

  
  public disabled: boolean = false;

  
  public tabindex: number = 0;

  
  public name: string;

  
  public value: any;

  public get inputId(): string {
    return `input-${this.id}`;
  }

  public selectedValue: any;
  private onChangeCallback: (value: any) => void;

  public onInputBlur() {
    this.onTouchedCallback();
  }

  public onRadioChanged(newValue: any) {
    if (this.disabled) {
      return;
    }

    if (newValue === this.selectedValue) {
      return;
    }

    this.selectedValue = newValue;
    this.onChangeCallback(newValue);
  }

  // Satisfying ControlValueAccessor interface.
  public writeValue(value: any) {
    if (value === undefined) {
      return;
    }

    this.selectedValue = value;
  }

  // onChanged callback set by ControlValueAccessor.
  public registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // onTouched callback set by ControlValueAccessor.
  public registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  // Satisfying ControlValueAccessor interface.
  /* istanbul ignore next */
  private onTouchedCallback(): () => void {
    return () => {};
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-radio',
  template: `<label class="sky-radio-wrapper">
  <input type="radio"
        [id]="inputId"
        [ngModel]="selectedValue"
        [disabled]="disabled"
        [name]="name"
        [value]="value"
        [tabIndex]="tabindex"
        [attr.aria-label]="label"
        [attr.aria-labelledby]="labelledBy"
        (blur)="onInputBlur()"
        (ngModelChange)="onRadioChanged($event)"/>
  <span class="sky-radio"></span>
  <ng-content select="sky-radio-label"></ng-content>
</label>
`,
  styles: [`.sky-radio-wrapper {
  display: inline-block;
  margin-bottom: 5px;
  cursor: pointer;
}

.sky-radio-wrapper input {
  opacity: 0;
  position: absolute;
  height: 22px;
  width: 22px;
  margin: 0;
  padding: 0;
  cursor: pointer;
}

.sky-radio {
  border-top: 1px solid #cdcfd2;
  border-bottom: 1px solid #cdcfd2;
  border-left: 1px solid #cdcfd2;
  border-right: 1px solid #cdcfd2;
  cursor: pointer;
  display: inline-block;
  height: 22px;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  width: 22px;
  text-align: center;
  font-size: 15px;
  border-radius: 50%;
  line-height: 19px;
}

.sky-radio-wrapper input:hover + .sky-radio {
  border: 2px solid #007ca6;
}

.sky-radio-wrapper input:checked + .sky-radio {
  background-color: #007ca6;
  border-color: #007ca6;
  border-width: 1px;
}

.sky-radio-wrapper input:checked + .sky-radio:before {
  color: #ffffff;
  content: "\\f00c";
  font-family: FontAwesome;
  font-size: 13px;
}

.sky-radio-wrapper input:disabled + .sky-radio {
  background-color: #eeeeef;
  border-top: 1px solid #e2e3e4;
  border-bottom: 1px solid #e2e3e4;
  border-left: 1px solid #e2e3e4;
  border-right: 1px solid #e2e3e4;
  cursor: default;
}

.sky-radio-wrapper input:focus + .sky-radio {
  outline: thin dotted;
  outline: -webkit-focus-ring-color auto 5px;
}
`],
  providers: [SKY_RADIO_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'label': [{ type: Input },],
'labelledBy': [{ type: Input },],
'id': [{ type: Input },],
'disabled': [{ type: Input },],
'tabindex': [{ type: Input },],
'name': [{ type: Input },],
'value': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
